import { SimuladorConsumoDetallado } from './simuladorConsumoDetallado.entity';
import { Length, IsNumberString } from 'class-validator';

export class SimuladorConsumosDet {
    Contrato: number;
    contratoNombre: string;
    Calibre: string;
    @Length(1, 6)
    Consumo: string;
    @Length(1, 3)
    @IsNumberString()
    NumHab: string;
    ImporteTotal: string;
    CnsHabDia: string;
    consumoAltoBajo: string;
    TextoAyuda: string;
    ConsumoFrecuencia: string;
    simConsumoDetallado: SimuladorConsumoDetallado[];
}